import { TextField } from "@mui/material";
import { FairPaySurveyResponseContext } from "contexts/FairPaySurveyResponse";
import { ChangeEvent, useContext } from "react";

import { makeDeepCopy } from "utils/updateLocalState";

const styles = {
  textField: {
    width: "100%",
    mb: 2,
    borderRadius: 4,
    "& fieldset.MuiOutlinedInput-notchedOutline": {
      borderColor: "black",
    },
  },
};

interface Props {
  name: string;
  value?: string | number;
  placeholder?: string;
  error?: string;
  onBlur?: (name: string, value?: string | number) => void;
  type?: string;
  endAdornment?: JSX.Element;
  startAdornment?: JSX.Element;
  required?: boolean;
}

const FairPayTextField = ({
  name,
  value,
  error,
  onBlur,
  placeholder = "Enter your answer here...",
  type = "text",
  endAdornment,
  startAdornment,
  required,
}: Props) => {
  const { setFairPaySurveyResponse } = useContext(FairPaySurveyResponseContext);
  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFairPaySurveyResponse((prev) => {
      const copy = makeDeepCopy(prev) || {};
      copy[name] = value;
      return copy;
    });
  };

  return (
    <TextField
      InputProps={{
        sx: { borderRadius: 4 },
        startAdornment,
        endAdornment,
      }}
      sx={styles.textField}
      placeholder={required ? `${placeholder} *` : placeholder}
      onChange={onChange}
      name={name}
      value={value}
      error={!!error}
      helperText={error}
      onBlur={onBlur ? () => onBlur(name, value) : undefined}
      type={type}
      required={required}
    />
  );
};

export default FairPayTextField;
